export const columns = [
  { name: 'id', label: 'Id', minWidth: 100, format(item) { return item.id_link } },
  { name: 'user_id', label: 'Matricula', minWidth: 100 },
  { name: 'complete_name', label: 'Nombre completo', minWidth: 100 },
  { name: 'email', label: 'Correo electrónico', minWidth: 100 },
  { name: 'company_id', label: 'Marca', minWidth: 100 },
  { name: 'membership_name', label: 'Membresía', minWidth: 100 },
  { name: 'is_active', label: 'Activo', minWidth: 100 },
  { name: 'actions', label: 'Acciones', minWidth: 100 }    
];